/*
  pdp-media-gallery-mobile 元素：移动端单图媒体卡片（变体第一张图，无轮播）。

  root 带 class="swiper-media-images" + data-variant-id，接入 VariantPicker._initSwiperMedias
  （theme.js）的整块替换/缓存链路——切变体时整卡由 Section Rendering 结果按序替换。
  该链路对每个锚点都会读 querySelector('.swiper') 上的 swiper 实例
  （缓存时取 realIndex，fetch 替换后调 destroy），没有实例会直接抛错并拖垮同 section
  其他 gallery 的变体切换。本卡没有轮播，这里给 .swiper 挂惰性 stub 满足契约；
  connectedCallback 每次插入（含缓存还原）都会重跑，属性已存在时跳过。
*/

class PdpMediaGalleryMobile extends HTMLElement {
  connectedCallback() {
    const swiperEl = this.querySelector('.swiper');
    if (swiperEl && !swiperEl.swiper) {
      swiperEl.swiper = { realIndex: 0, destroy() {} };
    }
  }
}

if (!window.customElements.get('pdp-media-gallery-mobile')) {
  window.customElements.define('pdp-media-gallery-mobile', PdpMediaGalleryMobile);
}
